import TrackedPage from './TrackedPage'

export default TrackedPage
